angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-webinar-factory',
        function ($api, $factory) {
            $api.factory.webinar = $factory;
        },
    ])
    .factory('graph-webinar-factory', [
        '$q',
        'graph-api-client',
        'graph-participant-factory',
        'graph-like-factory',
        'graph-document-factory',
        'graph-photo-factory',
        'graph-video-factory',
        'graph-post-factory',
        'graph-news-factory',
        'graph-search-factory',
        'graph-blacklist-factory',
        function ($q, client, participants, likes, documents, photos, videos, posts, news, search, blacklists) {
            var WEBINAR = 'webinar';

            /**
             *  @type {String}
             */
            return {
                // region: This is how it should be done now

                uploadWebinarPhoto: uploadWebinarPhoto,
                attachHeaderImage: attachHeaderImage,
                attachDescriptionImage: attachDescriptionImage,

                // endregion: This is how it should be done now

                query: function (id, options) {
                    return client.get([id, 'webinars'], options);
                },
                read: function (id, options) {
                    return client.get(['webinar', id], options);
                },
                create: function (data, options) {
                    return client.post(['webinars'], data, options);
                },
                update: function (id, data, options) {
                    return client.post(['webinar', id], data, options);
                },
                start: function (id, options) {
                    return client.post(['webinar', id, 'start'], undefined, options);
                },
                end: function (id, options) {
                    return client.post(['webinar', id, 'end'], undefined, options);
                },
                cancel: function (id, options) {
                    return client.post(['webinar', id, 'cancel'], undefined, options);
                },
                delete: function (id, options) {
                    return client.delete(['webinar', id], options);
                },
                queryRelatedProducts: function (webinarId) {
                    return client.get(['webinar', webinarId, 'related-products']);
                },
                addRelatedProduct: function (webinarId, productUrl) {
                    return client.post(['webinar', webinarId, 'related-products'], { url: productUrl });
                },
                removeRelatedProduct: function (webinarId, linkId) {
                    return client.delete(['webinar', webinarId, 'related-product', linkId]);
                },
                participants: function (id) {
                    return participants.entry(WEBINAR, id, 'participants');
                },
                blacklists: function (id) {
                    return blacklists.entry(WEBINAR, id);
                },
                likes: function (id) {
                    return likes.entry(WEBINAR, id);
                },
                documents: function (id) {
                    return documents.entry(WEBINAR, id);
                },
                posts: function (id) {
                    return posts.entry(WEBINAR, id);
                },
                news: function (id) {
                    return news.entry(WEBINAR, id);
                },
                picture: function (id) {
                    return photos.entry(WEBINAR, id, 'picture');
                },
                photos: function (id) {
                    return photos.entry(WEBINAR, id, 'photos');
                },
                videos: function (id) {
                    return videos.entry(WEBINAR, id, 'videos');
                },
                meeting: function (id, options) {
                    return client.get(['webinar', id, 'meeting'], options);
                },
                search: function (query, options) {
                    return search.entry(WEBINAR).search(query, options);
                },
                getMyProfile: function () {
                    return client.get(['me', 'profile']);
                },
                getTimetableLectures: function (id, options) {
                    return client.get([id, 'webinars', 'timetable'], options);
                },
                googleCalendarSync: function (webinar) {
                    return new Promise((resolve, reject) => {
                        gapi.load('client:auth2', function () {
                            gapi.client
                                .init({
                                    //todo remove from here to server, getGoogleCredentials req
                                    apiKey: 'AIzaSyB2fK-haHvptsG1rX6FWhYz5PHzIQOxNhE',
                                    clientId:
                                        '217521876447-k107gsv3gaa855vn33enqtlq8iikridp.apps.googleusercontent.com',
                                    scope: 'profile https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/calendar',
                                })
                                .then(
                                    function () {
                                        if (!gapi.auth2.getAuthInstance().isSignedIn.get()) {
                                            gapi.auth2.getAuthInstance().signIn();
                                        }

                                        gapi.auth2.getAuthInstance().isSignedIn.listen(updateSigninStatus);

                                        updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
                                    },
                                    () => reject()
                                );
                        });

                        function updateSigninStatus(isSignedIn) {
                            if (isSignedIn) {
                                makeApiCall();
                            }
                        }

                        //    make request
                        function makeApiCall() {
                            gapi.client.load('calendar', 'v3', function (res) {
                                var request = gapi.client.calendar.events.insert({
                                    calendarId: 'primary',
                                    resource: googleEventObject(webinar),
                                });
                                request.execute(function (event) {
                                    console.log('Event created: ' + event);
                                    resolve(event);
                                });
                            });
                        }

                        function googleEventObject(event) {
                            return {
                                summary: event.name,
                                description: event.description,
                                start: {
                                    dateTime: event.started_at,
                                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                },
                                end: {
                                    dateTime: event.ended_at,
                                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                },
                                recurrence: ['RRULE:FREQ=DAILY;COUNT=2'],
                                // 'attendees': [
                                //     {'email': 'lpage@example.com'},
                                //     {'email': 'sbrin@example.com'}
                                // ],
                                reminders: {
                                    useDefault: false,
                                    overrides: [
                                        { method: 'email', minutes: 24 * 60 },
                                        { method: 'popup', minutes: 10 },
                                    ],
                                },
                            };
                        }
                    });
                },
            };

            /**
             * Upload a photo and associate it with a given Webinar ID.
             *
             * Resolves on success with photo entity data.
             * Rejects with upload error message.
             *
             * @param {string|number} webinarId
             * @param {{name: string, data64: string}} photoData
             * @returns {ng.IPromise}
             */
            function uploadWebinarPhoto(webinarId, photoData) {
                // Not important in case of `upload` method. In other cases it changes the called API endpoint.
                var photosEntryTerm = 'photos';
                var photosEntry = photos.entry(WEBINAR, webinarId, photosEntryTerm);
                var uploadData = { name: photoData.name, photo: photoData.data64 };

                return photosEntry.upload(uploadData, {}).then(function (response) {
                    if (response.data.state !== 0) {
                        return $q.reject('The file is too large or the format is incorrect.');
                    }

                    return response.data.data;
                });
            }

            /**
             * Set given photo as description image for Webinar.
             *
             * @param {string|number} webinarId
             * @param {string|number} photoId
             * @returns {angular.IPromise<object>}
             */
            function attachDescriptionImage(webinarId, photoId) {
                // Using this term will call a dedicated endpoint for setting the description_image_id on Webinar entry.
                var photosEntryTerm = 'description-image';
                var photosEntry = photos.entry(WEBINAR, webinarId, photosEntryTerm);

                return photosEntry.attach(photoId, {}).then(function (response) {
                    return response.data.state === 0 ? response.data.data : $q.reject();
                });
            }

            /**
             * Set given photo as header image of Webinar
             *
             * @param {string|number} webinarId
             * @param {string|number} photoId
             * @returns {angular.IPromise<object>}
             */
            function attachHeaderImage(webinarId, photoId) {
                var photosEntryTerm = 'picture';
                var photosEntry = photos.entry(WEBINAR, webinarId, photosEntryTerm);

                return photosEntry.attach(photoId, {}).then(function (response) {
                    return response.data.state === 0 ? response.data.data : $q.reject();
                });
            }
        },
    ]);
